import { breakpoint, CardContent } from '@cmctechnology/phoenix-stockbroking-web-design';
import styled from 'styled-components';

export const FullWidthCardContent = styled(CardContent)`
  @media (max-width: ${breakpoint.mobile}) {
    width: 100%;
  }
`;
